import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import AskDelaChatContainer from './AskDelaChatContainer'
import { ChatInstanceId, useChatInstanceId } from './useChatInstanceId'

export interface ProjectWorkspaceAskDelaChatProps {}

const ProjectWorkspaceAskDelaChat: React.FC<ProjectWorkspaceAskDelaChatProps> = () => {
    const { projectId } = useParams<{ projectId?: string }>()

    const [chatInstanceId] = useState<ChatInstanceId>(
        useChatInstanceId(projectId)
    )

    return <AskDelaChatContainer chatInstanceId={chatInstanceId} />
}

export default ProjectWorkspaceAskDelaChat
